























































import { defineComponent, useContext } from "@nuxtjs/composition-api";
import { useGtm } from "~/composables";
import { getLocalizedPath, isExternalUrl } from "~/helpers/getLocalizedPath";

export default defineComponent({
  name: "MenuList",
  components: {},
  props: {
    menuList: {
      type: Array,
      default: () => [],
    },
    historyMenu: {
      type: Array,
      default: () => [],
    },
  },
  setup() {
    const { app: { i18n } } = useContext();
    const { eventCustomlinksInteracted } = useGtm();

    const navigationTracking = (menu) => {
      eventCustomlinksInteracted({
        "eventlabel": menu.title,
        "eventCategory": "Primary Navigation Links",
      });
    };
    const getMenuLink = (urlKey) => getLocalizedPath(urlKey, i18n);

    return {
      navigationTracking,
      getMenuLink,
      isExternalUrl,
    };
  },
});
